import moment from "moment";
import { formatMoney } from "../features/utils/formatMoney";

export const contructAccountStatementPDF = (data) => {
  const debits = data?.transactions?.filter((item) => !item?.isCredit) || [];
  const credits = data?.transactions?.filter((item) => item?.isCredit) || [];
  return {
    account: {
      name: data?.account?.detail?.agencyName,
      street: data?.account?.detail?.address?.businessLocation,
      city: data?.account?.detail?.address?.addressTwo,
      state: data?.account?.detail?.address?.lga,
      email: data?.account?.businessEmail || data?.account?.email,
      customerId: "---",
      accountNumber: data?.bankAccount?.accountNumber || "---",
      accountOpenDate: data?.account?.createdAt
        ? moment(data?.account?.createdAt).format("DD MMM YYYY")
        : "---",
      accountStatus: data?.account?.accountStatus || "---",
      totalBookingsMade: data?.meta?.totalBookingsMade || "---",
      commissionEarned: formatMoney(data?.meta?.commissionEarned) || "---",
      markupEarned: formatMoney(data?.meta?.markupEarned) || "---",
      serviceFeesPaid: formatMoney(data?.meta?.serviceFeesPaid) || "---",
      refunds: formatMoney(data?.meta?.refunds) || "---",
      netEarnings: formatMoney(data?.meta?.netEarnings) || "---",
      walletBalance: formatMoney(data?.meta?.walletBalance) || "---",
      subscriptionStatus: data?.meta?.subscriptionStatus || "---",
    },
    meta: {
      from: moment(data?.meta?.startDate).format("DD/MM/YYYY") || "---",
      to: moment(data?.meta?.endDate).format("DD/MM/YYYY") || "---",
      numberOfTransactions: data?.meta?.numberOfTransactions,
      drCount: debits.length || "---",
      crCount: credits.length || "---",
      debits: formatMoney(data?.meta?.totalDebit) || "---",
      credits: formatMoney(data?.meta?.totalCredit) || "---",
      closingBalance: formatMoney(data?.meta?.closingBalance) || "---",
      totalTransactionAmount:
        formatMoney(data?.meta?.totalTransactionAmount) || "---",
      generatedOn:
        moment(data?.meta?.generatedOn).format("DD/MM/YYYY") || "---",
      generatedBy: data?.meta?.generatedBy || "---",
    },
    records:
      data?.transactions?.map((transaction) => {
        return {
          date: moment(transaction?.createdAt).format("DD/MM/YYYY") || "---",
          action: transaction?.reason || "---",
          description: transaction?.description || "---",
          debits: transaction?.isCredit
            ? "---"
            : formatMoney(transaction?.amount),
          credits: transaction?.isCredit
            ? formatMoney(transaction?.amount)
            : "----",
          commission: transaction?.commision
            ? formatMoney(transaction.commision)
            : "---",
          markup: transaction?.markup ? formatMoney(transaction.markup) : "---",
          balance: transaction?.balance
            ? formatMoney(transaction.balance)
            : "---",
        };
      }) || [],
  };
};
